import { Result } from "../../request/models/events";

export interface FetchDeviceListResponseBody {
  device_details: ConnectedDevice[],
  result: Result
}

export interface DeviceDisconnectedEventBody {
  deviceId: string
}

export enum InstallationStatus {
  SUCCESS = "success",
  ERROR = "error",
  INSTALLING = "installing"
}

export type Status = InstallationStatus.SUCCESS | InstallationStatus.ERROR | InstallationStatus.INSTALLING;

export interface GadgetInstallationStatus {
  progress: number,
  status: Status;
}

export interface GadgetInstallationStatusOnAllDevices {
  successfullGadgetInstallationNo: number;
  failedGadgetInstallationNo: number;
  remainingDevices: ConnectedDevice[];
}

export interface GadgetInstallationCompletedBody {
  status: Status;
  sourceDeviceId: string;
  gadgetId: number;
}

export interface GadgetInstallationProgressBody {
  sourceDeviceId: string;
  progress: number;
  gadgetId: number;
}

export interface DeviceVersion {
  major: number;
  minor: number;
  patch: number;
}

export enum DevicePlatform {
  WINDOWS = "WINDOWS",
  MAC = "MAC",
  LINUX = "LINUX"
}

export interface ConnectedDevice {
  id: string,
  connection_id: string;
  core_name: string;
  core_version: string;
  debug_mode: boolean;
  manufacturer: string;
  name: string;
  online: boolean;
  platform: DevicePlatform;
  serial_number: string;
  user_id: string;
  version: DeviceVersion
}